import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";
import { API_AXIOS } from "../../http/interceptor";

const getDashboard = async () => {
  try {
    const { data } = await API_AXIOS.get(Apis.dashboard);
    return { data };
  } catch (error) {
    return {
      error: error.response ? error.response.data : error.message,
    };
  }
};

export const dashboardDataApi = createApi({
  reducerPath: "dashboard",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Dashboard"],
  endpoints: (builder) => ({
    getDashboardData: builder.query({
      queryFn: getDashboard,
      providesTags: ["Dashboard"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetDashboardDataQuery } = dashboardDataApi;






export const dashboardPnLDataApi = createApi({
  reducerPath: "dashboardPnL",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["dashboardPnL"],
  endpoints: (builder) => ({
    getDashboardPnLData: builder.query({
      query: ({ duration }) => ({
        url: `${Apis.dashboardProfitAndLoss}/${duration}`,
      }),
      providesTags: ["dashboardPnL"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetDashboardPnLDataQuery } = dashboardPnLDataApi;
